<template>
  <div>
    <v-layout
      fill-height
      align-center
    >
      <!-- NOTES -->
      <v-spacer />
      <v-btn
        :disabled="!canAdd"
        color="primary"
        small
        icon
        @click="showNoteDialog"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-dialog
        v-model="noteDialog"
        persistent
        width="500"
      >
        <v-card>
          <v-card-text>
            <v-form>
              <v-textarea
                v-model="note"
                label="Заметка"
              />

              <v-btn
                small
                color="primary"
                @click="addNote"
              >
                Ок
              </v-btn>
              <v-btn
                small
                @click="noteDialog = false"
              >
                Отмена
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <div class="pa-1 worked-variant-table">
      <v-list>
        <v-list-tile
          v-for="item in notes"
          :key="item.id"
          class="compact"
        >
          <v-list-tile-content>
            <div>
              <span style="color: rgba(0,0,0,.54);">{{ item.author }}: {{ item.date | dateTime }}</span>
              <span>{{ item.text }}</span>
            </div>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </div>
  </div>
</template>
<script>
import { createNote } from "../../../backend/shipmentRequestsApi.js";

export default {
  props: ["disabled", "items", "id"],
  data() {
    return {
      noteDialog: false,
      note: "",
    };
  },
  computed: {
    canAdd() {
      return !this.disabled;
    },
    notes() {
      return this.items;
    },
  },
  methods: {
    async addNote() {
      await createNote(this.id, this.note);
      this.noteDialog = false;
      this.note = "";
      this.$emit("add");
    },
    showNoteDialog() {
      if (this.canAdd) {
        this.noteDialog = true;
      }
    },
  },
};
</script>
